<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - {{name}}</h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="handleSubmit()" class="button primary">Lagre endringer</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <TheLoader :active="$store.getters.isFormLoading"/>
    <div v-if="!$store.getters.isFormLoading" class="content-container flex-row">
      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">
          <fieldset>
            <div class="grid-x grid-padding-x">
              <TheTextInput containerClassName="cell large-4" label="Id" name="Id" v-model.trim="item.id" :disabled="true"/>
              <TheTextInput containerClassName="cell large-4" label="Identifier" name="Identifier" v-model.trim="item.Identifier" required v-validate="'required|max:255'"/>
              <TheTextInput containerClassName="cell large-4" label="Navn" name="Navn" v-model.trim="item.Navn" maxlength="255" required v-validate="'required|max:255'"/>

              <div class="cell">
                <label>Etikett type *</label>
                <ul class="checkbox-list">
                  <li>
                    <div class="input-container checkbox">
                      <input type="checkbox" id="small" :value="true" v-model="labeltypes.Small">
                      <label for="small">Liten</label>
                      <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
                    </div>
                  </li>
                  <li>
                    <div class="input-container checkbox">
                      <input type="checkbox" id="medium" :value="true" v-model="labeltypes.Medium">
                      <label for="medium">Medium</label>
                      <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
                    </div>
                  </li>
                  <li>
                    <div class="input-container checkbox">
                      <input type="checkbox" id="large" :value="true" v-model="labeltypes.Large">
                      <label for="large">Stor</label>
                      <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
                    </div>
                  </li>
                  <li>
                    <div class="input-container checkbox">
                      <input type="checkbox" id="wine" :value="true" v-model="labeltypes.Wine">
                      <label for="wine">Vinetikett</label>
                      <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
                    </div>
                  </li>
                </ul>
                <div class="input-container" :class="{'form-error': errors.has('typevalue')}">
                  <input type="hidden" name="hastypevalue" v-model="hasSelectedType" v-validate="'max:4'">
                  <span class="form-error-label" style="text-align: left; position: initial;" v-if="errors.has('hastypevalue')">
                    Velg og fyll inn minst en etikett type
                  </span>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'

export default {
  name: 'InstillingerOppgjordebugEdit',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    servicename: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      service: InstillingerService(this.servicename),
      edit: false,
      types: [],
      item: {},
      labeltypes: {
        'Small': false,
        'Medium': false,
        'Large': false
      }
    }
  },
  created () {
    // Set form to loading
    this.setFormLoading(true)

    // Edit mode
    this.edit = !!this.$route.params.id

    // Load
    this.fetch()
  },
  computed: {
    hasSelectedType: function () {
      if (this.labeltypes.Small === true) {
        return true
      }

      if (this.labeltypes.Medium === true) {
        return true
      }

      if (this.labeltypes.Large === true) {
        return true
      }

      if (this.labeltypes.Wine === true) {
        return true
      }

      return false
    }
  },
  watch: {
    'hasSelectedType': function (newVal) {
      if (newVal !== undefined) {
        this.$validator.validate('hastypevalue')
      }
    }
  },
  methods: {
    fetch: function () {
      if (!this.edit) {
        this.setFormLoading(false)
      } else {
        this.service.view(this.$route.params.id)
          .then((response) => {
            this.item = response.data

            if (this.item.label_types_array.includes('Small')) {
              this.labeltypes.Small = true
            }

            if (this.item.label_types_array.includes('Medium')) {
              this.labeltypes.Medium = true
            }

            if (this.item.label_types_array.includes('Large')) {
              this.labeltypes.Large = true
            }

            if (this.item.label_types_array.includes('Wine')) {
              this.labeltypes.Wine = true
            }
          })
          .catch(() => {
            this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn label')
            this.onCancel()
          })
          .then(() => {
            this.setFormLoading(false)
          })
      }
    },

    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      // Get label types
      let postTypes = []

      if (this.labeltypes.Small) {
        postTypes.push('Small')
      }
      if (this.labeltypes.Medium) {
        postTypes.push('Medium')
      }
      if (this.labeltypes.Large) {
        postTypes.push('Large')
      }
      if (this.labeltypes.Wine) {
        postTypes.push('Wine')
      }

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            let post = {
              id: this.edit ? this.item.id : null,
              Identifier: this.item.Identifier,
              Navn: this.item.Navn,
              Labeltypes: postTypes
            }

            this.service.save(post.id, post)
              .then((response) => {
                this.$helpers.showSuccessAlert('Printer er lagret')

                this.item = response.data

                if (!this.edit) {
                  this.$router.go(-1)
                }
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                } else {
                  this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen', 'danger')
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    onCancel: function () {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerOppgjordebugEdit.vue